// removed by extract-text-webpack-plugin
module.exports = {"switch":"toggle-switch---switch---3EchW","switch-sm":"toggle-switch---switch-sm---31JjY","switchSm":"toggle-switch---switch-sm---31JjY","toggle":"toggle-switch---toggle---mncCu","disabled":"toggle-switch---disabled---eCY9b","checked":"toggle-switch---checked---3aC9B","toggle-sm":"toggle-switch---toggle-sm---20q-N","toggleSm":"toggle-switch---toggle-sm---20q-N","round":"toggle-switch---round---1fvZN"};


//////////////////
// WEBPACK FOOTER
// ./src/index.styl
// module id = 2
// module chunks = 0